import { InstructionComponentProps } from "../InstructionComponent"

const ReportLocationInstruction: InstructionComponentProps = {
    name: "Wo finde ich wöchentliche Berichte zu meinen Patient:innen?",
    path: "/help/professional/report_location",
    description: (
        <>
            Als Ärzt:in wird Ihnen einmal wöchentlich (Sonntag 23:00 Uhr) ein
            Bericht pro Patient:in per Mail zugesendet. Dieser Bericht enthält
            eine Übersicht über die gesammelten Daten und Fragebögen der letzten
            zwei Wochen der Patient:innen, sodass Sie sich schnell einen
            Überblick über den Verlauf der Therapie verschaffen können.
            Alternativ können Sie aktuelle und vergangene Berichte händisch
            herunterladen.
        </>
    )
}

export default ReportLocationInstruction
